import NotFoundError from 'components/message/not-found';
import { NextPage } from 'next';

const HomePage: NextPage = () => <NotFoundError />;

export default HomePage;
